const allaccpayableagingsummary = { data: [], loading: true };
export const GetAllAccPayableAgingSummary = (state = allaccpayableagingsummary, action) => {
  switch (action.type) {
    case "get_allaccpayableagingsummary":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};
